module.exports = __webpack_public_path__ + "fonts/TatrabankaSansV1-0-Bold.aefa8439.woff";